import { defineMessages, FormattedMessage } from 'react-intl';
import type { NavItem } from '@platform/shared';

const m = defineMessages({
  title: { id: 'coming.title', defaultMessage: 'Not here yet', description: 'Title of the placeholder a nav item renders before its package ships' },
  body: { id: 'coming.body', defaultMessage: 'This page arrives with {package}. The route is already in the nav so that links to it are stable from day one.', description: 'Body of the placeholder; package is the release that ships the page, e.g. "v3.9a user stories"' },
});

/** What an unshipped nav item renders (planning-app.md §3 *Navigation from v3.8*): the release that fills it. Every item has shipped since `v3.9a`; the component stays for the next one. */
export function ComingPage({ item }: { item: NavItem }) {
  return (
    <div className="empty" data-testid="coming-page" data-nav={item.id}>
      <b>
        <FormattedMessage {...m.title} />
      </b>
      <FormattedMessage {...m.body} values={{ package: <span translate="no">{item.package}</span> }} />
    </div>
  );
}
